import React from "react";
import PortalCard from "../components/portal/PortalCard";
import Footer from "../shared/Footer";
import "../styles/portal.css";

export default function AboutPage() {
  return (
    <div style={{ width: "100%", margin: 0, padding: 0, overflowX: "hidden", backgroundColor: "#f4f7fb", minHeight: "100vh" }}>

      {/* Hero Banner */}
      <div style={heroBannerStyle}>
        <div style={heroContentStyle}>
          <h1 style={heroTitleStyle}>About Us</h1>
          <p style={heroSubheadStyle}>Comic-booking since 1985.</p>
        </div>
      </div>

      {/* Content area */}
      <div style={pageBodyStyle}>

        {/* Section 1 — Who We Are */}
        <PortalCard variant="default" style={cardOverrideStyle}>
          <p style={pullQuoteStyle}>
            Comic-booking since 1985. Incorporated in December 1984.
          </p>

          <p style={bodyTextStyle}>
            Ben Dunn is our founder. Joe Dunn is our publisher. They're bros.
          </p>

          <p style={bodyTextStyle}>
            Their ongoing mission: publish the coolest creator-owned comics on Earth. Hence the name.
          </p>

          <p style={bodyTextStyle}>
            Antarctic Press has published some big hits like Ben Dunn's <strong>Ninja High School</strong>,{" "}
            <strong>Warrior Nun Areala</strong> (check it out on Netflix — #SaveWarriorNun),{" "}
            Fred Perry's <strong>Gold Digger</strong>, and over 5,000 other comic titles.
          </p>

          <p style={allCreatorOwnedStyle}>All CREATOR-OWNED.</p>

          <p style={bodyTextStyle}>
            Because there are two kinds of people that we believe must win in the world of comics:
            the creators and the fans.
          </p>

          <p style={bodyTextStyle}>
            We're located in San Antonio, Texas, btw. Yee-haw! Come on down and see us some time.
          </p>

          <div style={dividerStyle} />

          <h2 style={sectionHeadingStyle}>Get in Touch</h2>

          <div style={addressWrapStyle}>
            <div style={addressBlockStyle}>
              ANTARCTIC PRESS<br />
              4334 Parkwood Dr.<br />
              San Antonio, TX 78218<br />
              Phone:{" "}
              <a href="tel:+12106140396" style={{ color: "#43c6f9" }}>
                1 (210) 614-0396
              </a>
            </div>
          </div>
        </PortalCard>
      </div>
      <Footer style={{ marginTop: 0 }} />
    </div>
  );
}

const heroBannerStyle = {
  backgroundColor: "#0d1b2a",
  padding: "64px 16px",
};

const heroContentStyle = {
  maxWidth: "860px",
  margin: "0 auto",
};

const heroTitleStyle = {
  color: "#ffffff",
  fontWeight: 700,
  fontSize: "2.5rem",
  margin: "0 0 0.4rem 0",
};

const heroSubheadStyle = {
  color: "#43c6f9",
  fontSize: "1.1rem",
  margin: 0,
};

const pageBodyStyle = {
  maxWidth: "860px",
  margin: "0 auto",
  padding: "32px 16px 24px",
};

const cardOverrideStyle = {
  marginBottom: "24px",
  padding: "2rem",
};

const pullQuoteStyle = {
  color: "#114c96",
  fontWeight: 700,
  fontSize: "1.3rem",
  textAlign: "center",
  marginBottom: "24px",
};

const bodyTextStyle = {
  color: "#222222",
  lineHeight: 1.8,
  margin: "0 0 1rem 0",
};

const allCreatorOwnedStyle = {
  color: "#114c96",
  fontWeight: 700,
  fontSize: "1.4rem",
  textAlign: "center",
  margin: "32px 0",
};

const dividerStyle = {
  borderTop: "1px solid #e0e0e0",
  margin: "32px 0",
};

const sectionHeadingStyle = {
  color: "#114c96",
  fontWeight: 700,
  fontSize: "1.4rem",
  textAlign: "center",
  marginBottom: "24px",
  marginTop: 0,
};

const addressWrapStyle = {
  display: "flex",
  justifyContent: "center",
  marginBottom: "8px",
};

const addressBlockStyle = {
  backgroundColor: "#0d1b2a",
  color: "#ffffff",
  fontFamily: "monospace",
  padding: "16px",
  borderRadius: "8px",
  display: "inline-block",
  lineHeight: 1.9,
  textAlign: "center",
};
